$(function(){
	$('#btnEnter img').on('mouseover',function() {
		$(this).attr('src', $(this).attr('src').replace('_enter', '_enter_on'));
	});
	$('#btnEnter img').on('mouseout',function() {
		$(this).attr('src', $(this).attr('src').replace('_enter_on', '_enter'));
	});
});



/*****************
 ** WEBPACK FOOTER
 ** ../common/pc/js/verification.js
 ** module id = 3
 ** module chunks = 0
 **/